import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 39,
  height: 39,
}

const stove = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 38.356 38.333'
  >
    <g fill={color}>
      <path d='M38.355,4.207a1.74,1.74,0,0,0-1.738-1.738H32.874V1.342A1.343,1.343,0,0,0,31.532,0H23.809a1.344,1.344,0,0,0-1.342,1.342V2.469H15.888V1.342A1.344,1.344,0,0,0,14.546,0H6.823A1.344,1.344,0,0,0,5.481,1.342V2.469H1.738A1.74,1.74,0,0,0,0,4.207V7.916a1.731,1.731,0,0,0,.46,1.176A1.73,1.73,0,0,0,0,10.268V33.177a1.74,1.74,0,0,0,1.738,1.738h.178V36.6a1.738,1.738,0,0,0,1.736,1.736H21.079a.562.562,0,1,0,0-1.124H3.652A.613.613,0,0,1,3.04,36.6V34.915H35.314V36.6a.613.613,0,0,1-.612.612H23.681a.562.562,0,1,0,0,1.124H34.7A1.738,1.738,0,0,0,36.439,36.6V34.915h.178a1.74,1.74,0,0,0,1.738-1.738V10.268a1.732,1.732,0,0,0-.46-1.176,1.732,1.732,0,0,0,.46-1.176ZM23.591,1.342a.218.218,0,0,1,.218-.218h7.723a.218.218,0,0,1,.218.218V2.469H23.591Zm-16.986,0a.218.218,0,0,1,.218-.218h7.723a.218.218,0,0,1,.218.218V2.469H6.605ZM37.231,33.177a.615.615,0,0,1-.614.614H1.738a.615.615,0,0,1-.614-.614V10.268a.615.615,0,0,1,.614-.614H36.617a.615.615,0,0,1,.614.614Zm0-25.261a.615.615,0,0,1-.614.614H1.738a.615.615,0,0,1-.614-.614V4.207a.615.615,0,0,1,.614-.614H36.617a.615.615,0,0,1,.614.614Zm0,0' />
      <path
        d='M82.266,55.152a1.93,1.93,0,1,0,1.93,1.93A1.932,1.932,0,0,0,82.266,55.152Zm0,2.736a.806.806,0,1,1,.806-.806A.807.807,0,0,1,82.266,57.888Zm0,0'
        transform='translate(-74.318 -51.021)'
      />
      <path
        d='M155.336,55.152a1.93,1.93,0,1,0,1.93,1.93A1.932,1.932,0,0,0,155.336,55.152Zm0,2.736a.806.806,0,1,1,.806-.806A.807.807,0,0,1,155.336,57.888Zm0,0'
        transform='translate(-141.915 -51.021)'
      />
      <path
        d='M309,55.152a1.93,1.93,0,1,0,1.93,1.93A1.932,1.932,0,0,0,309,55.152Zm0,2.736a.806.806,0,1,1,.806-.806A.807.807,0,0,1,309,57.888Zm0,0'
        transform='translate(-284.071 -51.021)'
      />
      <path
        d='M382.07,55.152a1.93,1.93,0,1,0,1.93,1.93A1.932,1.932,0,0,0,382.07,55.152Zm0,2.736a.806.806,0,1,1,.806-.806A.807.807,0,0,1,382.07,57.888Zm0,0'
        transform='translate(-351.663 -51.021)'
      />
      <path
        d='M87.748,171.938H71.406a.562.562,0,1,0,0,1.124H87.748a.2.2,0,0,1,.2.2v1.487a.2.2,0,0,1-.2.2H60.968a.2.2,0,0,1-.2-.2v-1.487a.2.2,0,0,1,.2-.2h7.811a.562.562,0,1,0,0-1.124H60.968a1.321,1.321,0,0,0-1.319,1.319v1.487a1.321,1.321,0,0,0,1.319,1.319h.752v12.47a1.942,1.942,0,0,0,1.94,1.94h21.4a1.942,1.942,0,0,0,1.94-1.94v-12.47h.752a1.321,1.321,0,0,0,1.319-1.319v-1.487a1.321,1.321,0,0,0-1.319-1.319Zm-1.876,16.6a.816.816,0,0,1-.816.816h-21.4a.817.817,0,0,1-.816-.816v-12.47H85.872Zm0,0'
        transform='translate(-55.181 -159.058)'
      />
      <path
        d='M145.6,257.836a.562.562,0,0,0,.414-.181l1.724-1.874a.562.562,0,1,0-.827-.761l-1.724,1.874a.562.562,0,0,0,.413.943Zm0,0'
        transform='translate(-134.177 -235.748)'
      />
      <path
        d='M151.948,264.509a.562.562,0,0,0,.794-.033l3.545-3.853a.562.562,0,0,0-.827-.761l-3.545,3.853A.562.562,0,0,0,151.948,264.509Zm0,0'
        transform='translate(-140.397 -240.227)'
      />
    </g>
  </svg>
)

export default stove
